<template>
    <div>
        <a
            :href="url"
            target="_blank"
            class="w-full p-2 bg-primary-500 text-white rounded flex items-center justify-center"
        >
            {{ field.label }}
        </a>
    </div>
</template>

<script>
export default {
    props: ['value', 'field', 'values'],
    computed: {
        url() {
            let url = this.field.atributos_extras.button_url || ''
            let matches = url.match(/%([^%]+?)%/g)
            for (let match of matches) {
                let attr = match.replace(/%/g, '')
                url = url.replace('%' + attr + '%', this.values[attr])
            }

            return url
        },
    },
}
</script>